<div *ngIf="sourceInfoData.sourceInfo != undefined" class="source-container">
  <ul class="tree" role="tree" [attr.aria-labelledby]="addQuestionHeaderId">
    <!-- Root Folder Treeitem -->
    <li
      #treeitem
      role="treeitem"
      aria-level="1"
      [attr.data-index]="rootFolderIndex"
      [attr.aria-expanded]="plusMinusSign !== 1 ? 'true' : 'false'"
      [attr.tabindex]="focusedIndex === rootFolderIndex ? 0 : -1"
      (keydown)="onTreeKeydown($event, rootFolderIndex, 'folder')"
      (focus)="onTreeItemFocus(rootFolderIndex, treeitem)"
      [ngClass]="{ 'treeitem-focused': focusedIndex === rootFolderIndex }"
    >
      <span class="align-folder" aria-hidden="true">
        <!-- Expand/Collapse icons -->
        <i
          class="dpg-icon dpg-icon-add icon-sm"
          [ngStyle]="{ display: plusMinusSign === 1 ? 'inline-block' : 'none' }"
          (click)="toggleFolder()"
        ></i>
        <i
          class="dpg-icon dpg-icon-subtract icon-sm"
          [ngStyle]="{  display: plusMinusSign !== 1 ? 'inline-block' : 'none' }"
          (click)="toggleFolder()"
        ></i>

        <!-- Folder Icon -->
        <i
          class="ahe-icon"
          [ngClass]="plusMinusSign !== 1 ? 'ahe-icon-openfolder' : 'ahe-icon-folder'"
        ></i>
      </span>

      <!-- Folder Title -->
      <span class="source-text">
        <strong>ISBN:</strong> {{ sourceInfoData.sourceInfo.isbn_title }}
        <strong>Author:</strong> {{ sourceInfoData.sourceInfo.author }}
        <strong>Edition:</strong> {{ sourceInfoData.sourceInfo.edition }}
      </span>

      <!-- Child Test Banks -->
      <ul class="active" *ngIf="plusMinusSign !== 1" role="group">
        <li
          #treeitem
          *ngFor="let bank of sourceInfoData.sourceInfo.banks; let i = index"
          class="d-flex"
          role="treeitem"
          aria-level="2"
          [attr.data-index]="i + 1"
          [attr.aria-selected]="checkedBank === i"
          [attr.tabindex]="focusedIndex === i + 1 ? 0 : -1"
          (keydown)="onTreeKeydown($event, i + 1, 'bank')"
          (focus)="onTreeItemFocus(i + 1, treeitem)"
          (click)="OnCheckboxSelect(bank, bank.title, $event, i)"
          [ngClass]="{
            'treeitem-focused': focusedIndex === i + 1,
            'highlight-bg': checkedBank === i
          }"
          [attr.aria-labelledby]="'bank-title-' + i"
        >
          <label for="{{ bank.title }}" class="bank-items p-right-3">
            <!-- Folder Icon -->
            <span class="padding-align" aria-hidden="true">
              <i class="ahe-icon" 
                [ngClass]="checkedBank === i ? 'ahe-icon-folder-white' : 'ahe-icon-folder'"
              ></i>
            </span>

            <!-- Bank Title -->
            <span
              [id]="'bank-title-' + i"
              class="source-text"
              #mySelectedBank
              (dblclick)="dblClickBank(bank, $event, i)"
              (click)="OnCheckboxSelect(bank, bank.title, $event, i)"
              [attr.title]="bank.title"
              [ngClass]="{ 'highlight-name': checkedBank === i }"
              role="presentation"
            >{{ bank.title | truncate: [[truncateTitle], '...'] }}</span>
          </label>
            <!-- Info Button -->
              <button
                #infoButton
                [id]="'info-btn-' + i"
                type="button"
                class="btn-link bank-info-btn p-0"
                data-dismiss="modal"
                (click)="OnBankInfoSelect(true, bank.ezid, bank.title, bank.virtualBankId)"
                [attr.tabindex]="focusedIndex === i + 1 ? 0 : -1"
                (keydown)="onInfoButtonKeydown($event, i + 1, bank, infoButton)"
                aria-haspopup="dialog"
                appTooltip="Bank Information"
                [alternateAriaLabel]="'Information of ' + bank.title"
              >
                <i class="fa fa-info-circle fa-fw bank-info-icon"></i>
              </button>
        </li>
      </ul>
    </li>
    <!-- My Questions Folder Treeitem -->
    <li
      #treeitem
      *ngIf="sourceInfoData.sourceInfo.myquestions"
      role="treeitem"
      aria-level="1"
      [attr.data-index]="myQuestionsIndex"
      [attr.tabindex]="focusedIndex === myQuestionsIndex ? 0 : -1"
      [attr.aria-selected]="checkedBank === myQuestionsIndex"
      (keydown)="onTreeKeydown($event, myQuestionsIndex, 'folder')"
      (focus)="onTreeItemFocus(myQuestionsIndex, treeitem)"
      (click)="OnCheckboxSelect(sourceInfoData.sourceInfo.myquestions, sourceInfoData.sourceInfo.myquestions.title, $event, myQuestionsIndex)"
      [ngClass]="{
        'treeitem-focused': focusedIndex === myQuestionsIndex,
        'highlight-bg': checkedBank === myQuestionsIndex
      }"
    >
      <span class="padding-align">
        <i class="ahe-icon" 
          [ngClass]="checkedBank === myQuestionsIndex ? 'ahe-icon-folder-white' : 'ahe-icon-folder'"
        ></i>
      </span>

      <span
        class="div-question source-text"
        [attr.title]="sourceInfoData.sourceInfo.myquestions.title"
        [ngClass]="{ 'highlight-name': checkedBank === -2 }"
        (dblclick)="dblClickBank(sourceInfoData.sourceInfo.myquestions, $event, -2)"
        (click)="
            OnCheckboxSelect(
              sourceInfoData.sourceInfo.myquestions,
              sourceInfoData.sourceInfo.myquestions.title,
              $event,
              -2
            )"
      >
        <strong>{{ sourceInfoData.sourceInfo.myquestions.title }}</strong>
      </span>
    </li>
  </ul>
</div>
<div>
  <div class="row m-0">
    <div class="col-md-12 col-lg-12 col-xl-12 line-divider">
      <div class="row" style="height: 54px; margin: 13px 4px 0 auto">
        <app-button
          *ngIf="!selectedBankObj"
          buttonText="Use Source"
          [disabled]="true"
          [purpose]="_buttonPurpose.Primary"
          (click)="selectBank()"
        ></app-button>
        <app-button
          *ngIf="selectedBankObj"
          buttonText="Use Source"
          [disabled]="false"
          [purpose]="_buttonPurpose.Primary"
          (click)="selectBank()"
        ></app-button>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showBankInfo != false"
  class="ahe-ui-alert-modal"
  id="bankInfo"
  role="dialog"
  tabindex="-1"
  aria-modal="true" 
  aria-labelledby="modalHeader"
  aria-describedby="modalBody"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : hideBankInfo(false)"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-bank-info-new">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="modalHeader" class="modal-title">Bank Info</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="hideBankInfo(false)"
            >
              <span
                aria-hidden="true"
                class="ahe-icon ahe-icon-close-white"
              ></span>
            </button>
          </div>
          <div class="modal-body-new" id="modalBody">
            <ng-container *ngIf="viewBankInfoData">
              <h3>Title: <span class="label-span">{{ bankTitle }}</span></h3>
              <dl class="question-types-list">
                <div *ngFor="let item of bankInfoDisplayData" class="question-type-item">
                  <dt class="label-question">{{ item.label }}</dt>
                  <dd class="label-span-question">{{ item.value }}</dd>
                </div>
              </dl>
            </ng-container>
          </div>
          <div class="modal-footer-new">
            <app-button
              buttonText="Ok"
              [purpose]="_buttonPurpose.Primary"
              (click)="hideBankInfo(false)"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
